import { LogTags } from "../Logger";

export type ExceptionParams = Omit<ErrorOptions, "cause"> & {
  message?: string;
  tags?: LogTags;
  cause: unknown;
};

export default class Exception extends Error {
  readonly tags?: LogTags;
  constructor(params: ExceptionParams) {
    super(params.message, params);
    this.tags = params.tags;
  }
}
